import { convertIsoDate, removeDelimeterFromString } from "@/lib/utils";

const IncidentData = ({
	incident,
}: {
	incident: Incident;
	index: number;
	toggleArrow: (indx: number) => void;
	expandedSections: Record<string, unknown>;
}) => {
	return (
		<>
			<div className="flex-1">
				<div className="flex items-center justify-between">
					<div>
						<div className="flex flex-col">
							<span className="text-sm text-gray-400">
								<strong>Workflow current step:</strong>{" "}
								{removeDelimeterFromString(incident?.activityId)}
							</span>
							<span className="text-sm text-gray-400">
								<strong>Status:</strong> failed
							</span>
							<span className="text-sm text-gray-400">
								<strong>Type:</strong> {incident?.type}
							</span>
							<span className="text-sm text-gray-400">
								<strong>Message:</strong> {incident?.message}
							</span>
							<span className="text-sm text-gray-400">
								{convertIsoDate(incident?.timestamp)}
							</span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default IncidentData;
